// extracted by mini-css-extract-plugin
export default {"container":"topics_container__gzHkx"};